import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BitbucketService } from '@app/shared';
import { ToastService } from '@teorema/patron';
import { CoreConfig } from 'src/app/models/core-config.model';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VersionHistoryComponent implements OnInit {
  config!: CoreConfig;
  tags: any[] = [];
  loadingTags: boolean = false;

  constructor(
    private bitbucketService: BitbucketService,
    private authService: AuthService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.config = this.authService.getCoreConfig();
    this.loadTags();
  }

  loadTags() {
    this.loadingTags = true;
    this.bitbucketService
      .getTagsInfo()
      ?.then(response => {
        this.tags = response;
      })
      .catch(error => {
        this.toastService.show({
          color: 'error',
          message: 'Houve um erro ao carregar os dados das versões',
        });
      })
      .finally(() => {
        this.loadingTags = false;
      });
  }
}
